import { Button, CircularProgress, Typography } from "@mui/material"; // Add Typography for message
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AppRoutes, LocalStorageItems } from "../../../constants";
import useApp from "../../../hooks/useApp";
import { getCitiesByCampaignId_V2 } from "../../../Services_V2/City.service";
import { getLocalStorageItem } from "../../../utils/localStorage";
import DonorCampaignCities from "../city-page/DonorCampaignCities";
import { CampaignQueryParam } from "../const";
import EmailMemberModal from "./EmailMemberModal/EmailMemberModal";
import styles from "./pick-city.module.css";

const PickCityPage = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [searchParams] = useSearchParams();

  const {
    state: { organization: organizationDetails },
  } = useApp();

  const campaignId = searchParams.get(CampaignQueryParam.CAMPAIGN_ID);
  const type = searchParams.get(CampaignQueryParam.TYPE);
  const email = searchParams.get(CampaignQueryParam.EMAIL);
  const token = getLocalStorageItem(LocalStorageItems.TOKEN);
  const [showCitySelection, setShowCitySelection] = useState(false);
  const [checkingCities, setCheckingCities] = useState(false);

  useEffect(() => {
    if (!campaignId) {
      // if (token) {
      //   navigate(AppRoutes.DONOR.DONATION, { replace: true });
      // } else {
      navigate(AppRoutes.DONOR.DONOR_LOGIN, { replace: true });
      // }
      return;
    }
    // if (!token) {
    //   const returnTo = `${window.location.pathname}${window.location.search}`;

    //   navigate(AppRoutes.DONOR.DONOR_LOGIN, {
    //     state: { returnTo },
    //     replace: true,
    //   });
    //   return;
    // }
    if (!email) {
      setOpen(true);
    }

    if (campaignId) {
      const checkCities = async () => {
        setCheckingCities(true);
        try {
          const res = await getCitiesByCampaignId_V2(campaignId);
          if (
            res?.success &&
            Array.isArray(res.data) &&
            res.data.length === 1
          ) {
            const singleCity = res.data[0];
            const params = new URLSearchParams({
              campaignId: String(campaignId),
              type: String(type || ""),
              city: singleCity._id,
              email: String(email),
            });
            navigate(`${AppRoutes.DONOR.DONATION_NGO}?${params.toString()}`, {
              replace: true,
            });
          }
        } catch (error) {
          console.error("Error fetching cities:", error);
        } finally {
          setCheckingCities(false);
        }
      };
      checkCities();
    }
  }, [campaignId, type]);

  const handlePickCityClick = useCallback(() => {
    setShowCitySelection(true);
  }, []);

  const hasValidParams = campaignId && type;

  if (checkingCities) {
    return (
      <div
        className={styles.container}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2>{organizationDetails?.title || ""}</h2>
          <p>{organizationDetails?.description || ""}</p>
        </div>

        <div className={styles.content}>
          {hasValidParams ? (
            <>
              {!showCitySelection ? (
                <div className={styles.btnContainer}>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={handlePickCityClick}
                    size="large"
                  >
                    Pick your city
                  </Button>
                </div>
              ) : (
                <DonorCampaignCities />
              )}
            </>
          ) : (
            <div className={styles.errorContainer}>
              <Typography variant="h6" color="error" gutterBottom>
                Invalid or Incomplete Link
              </Typography>
              <Typography variant="body1" color="text.secondary">
                No campaign Found
              </Typography>
            </div>
          )}
        </div>
      </div>

      <EmailMemberModal
        open={open}
        onClose={() => setOpen(false)}
        initialEmail="test@example.com"
      />
    </>
  );
};

export default PickCityPage;
